import { useState, useEffect } from 'react'

export function useLocation() {
  const [location, setLocation] = useState({})
  const [weather, setWeather] = useState({})

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        })
        fetch(
          `https://api.openweathermap.org/data/2.5/weather?lat=${position.coords.latitude}&lon=${position.coords.longitude}&appid=1b9dfb2ab952f4484f1733feb6ae7ff5
          `
        )
          .then((res) => res.json())
          .then((data) => setWeather(data))
      },
      (error) => console.error(error)
    )
  }, [])

  return { location, weather }
}
